export const PERMISSIONS = [
  'Create and send jobs',
  'See jobs created by others',
  'Update jobs created by others',
  'Add new team members',
  'Update company settings',
];
